// main.js
// Entry point for the edgard.realtor JavaScript bundle.

import initNav from './nav.js';
import initAnimations from './animations.js';
import initLazy from './lazy.js';
import initForms from './forms.js';

document.addEventListener('DOMContentLoaded', () => {
  initNav();
  initAnimations();
  initLazy();
  initForms();
});
